// base component
import { PhotoComponent } from './photo.component';

// components

export const PhotoModule = angular.module('topbroker.photos', [])
  .component('photo', PhotoComponent)
  .name;
